import { PlatformCode, PlatformKRName, PlatformENName } from 'type/common';

export const platform_KR_name_mapper: Record<PlatformCode, PlatformKRName> = {
	ig: '인스타그램',
	yt: '유튜브',
};

export const platform_KR_to_code_mapper: Record<PlatformKRName, PlatformCode> = {
	인스타그램: 'ig',
	유튜브: 'yt',
};

export const platform_EN_to_code_mapper: Record<PlatformENName, PlatformCode> = {
	Instagram: 'ig',
	Youtube: 'yt',
};

export const platform_EN_name_mapper: Record<PlatformCode, PlatformENName> = {
	ig: 'Instagram',
	yt: 'Youtube',
};

export const platform_index_mapper: Record<number, PlatformCode> = {
	0: 'ig',
	1: 'yt',
};
